module.exports = __webpack_public_path__ + "img/logoargen.aacba266.png";